import { render } from "./WaterPointItem.vue?vue&type=template&id=3081c2a2&scoped=true"
import script from "./WaterPointItem.vue?vue&type=script&lang=js"
export * from "./WaterPointItem.vue?vue&type=script&lang=js"

import "./WaterPointItem.vue?vue&type=style&index=0&id=3081c2a2&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3081c2a2"],['__file',"src/components/waterpoint/WaterPointItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3081c2a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3081c2a2', __exports__)) {
    console.log('reload')
    api.reload('3081c2a2', __exports__)
  }
  
  module.hot.accept("./WaterPointItem.vue?vue&type=template&id=3081c2a2&scoped=true", () => {
    console.log('re-render')
    api.rerender('3081c2a2', render)
  })

}


export default __exports__